import { useRef, useLayoutEffect, useState } from "react";
export var useLabelMargins = function useLabelMargins(_ref) {
  var fields = _ref.fields,
    filteredFields = _ref.filteredFields,
    formData = _ref.formData;
  // Store refs to label elements for height measurement
  var labelRefsMap = useRef(new Map());

  // Store calculated margins for each field
  var _useState = useState(new Map()),
    labelMargins = _useState[0],
    setLabelMargins = _useState[1];

  // Check if field is full-width (badge multi-select)
  var isFullWidth = function isFullWidth(field) {
    var _field$metadata, _field$metadata$valid, _field$metadata2;
    return !!((_field$metadata = field.metadata) !== null && _field$metadata !== void 0 && _field$metadata.multi_select && ((_field$metadata$valid = (_field$metadata2 = field.metadata) === null || _field$metadata2 === void 0 || (_field$metadata2 = _field$metadata2.valid_values) === null || _field$metadata2 === void 0 ? void 0 : _field$metadata2.length) !== null && _field$metadata$valid !== void 0 ? _field$metadata$valid : 0) > 0);
  };

  // Measure label heights and calculate margins
  useLayoutEffect(function () {
    var newMargins = new Map();

    // Build runs of fields separated by full-width fields
    // Each run contains fields that are in consecutive rows
    var runs = [];
    var currentRun = [];
    fields.forEach(function (fieldName) {
      var field = filteredFields.find(function (f) {
        return f.field_name === fieldName;
      });
      if (!field) return;

      // If we encounter a full-width field, end current run and start new one
      if (isFullWidth(field)) {
        if (currentRun.length > 0) {
          runs.push(currentRun);
          currentRun = [];
        }
        // Full-width fields don't participate in pairing
        return;
      }

      // Regular field - add to current run
      currentRun.push(fieldName);
    });

    // Don't forget the last run
    if (currentRun.length > 0) {
      runs.push(currentRun);
    }

    // Process each run - pair fields within the run
    runs.forEach(function (run) {
      for (var i = 0; i < run.length; i += 2) {
        var leftFieldName = run[i];
        var rightFieldName = run[i + 1];
        if (!rightFieldName) break; // No pair for the last field if odd count

        // Get label heights
        var leftLabelEl = labelRefsMap.current.get(leftFieldName);
        var rightLabelEl = labelRefsMap.current.get(rightFieldName);
        if (leftLabelEl && rightLabelEl) {
          var leftHeight = leftLabelEl.offsetHeight;
          var rightHeight = rightLabelEl.offsetHeight;

          // Calculate margin needed for the field with shorter label
          if (leftHeight > rightHeight) {
            var margin = leftHeight - rightHeight;
            newMargins.set(rightFieldName, margin);
          } else if (rightHeight > leftHeight) {
            var _margin = rightHeight - leftHeight;
            newMargins.set(leftFieldName, _margin);
          }
        }
      }
    });
    setLabelMargins(newMargins);
  }, [fields, formData, filteredFields]);
  return {
    labelMargins: labelMargins,
    labelRefsMap: labelRefsMap
  };
};